import axios from 'axios';
import { API_URL } from '../config';

// S311: "Şifremi unuttum" ve "Parola belirle" uçları. Üçü de OTURUMSUZ, bu yüzden
// `apiClient` değil ayrı bir istemci (auth.ts'teki `authClient` ile aynı desen):
// `apiClient` 401'de oturumu silip /login'e atar ve hata bildirimini antd `message`
// ile basar; bu ekranlar hatayı kendi formunda gösteriyor.
const parolaClient = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

/** Davet e-postası mı, parola sıfırlama mı: sayfa başlığını bu seçer. */
export type BelirtecAmaci = 'davet' | 'sifirlama';

export interface BelirtecBilgisi {
  email: string;
  amac: BelirtecAmaci;
}

export const parolaApi = {
  // Sunucu adresin kayıtlı olup olmadığını SÖYLEMEZ: her durumda 200 döner (429 hariç).
  unuttum: async (email: string): Promise<void> => {
    await parolaClient.post('/api/parola/unuttum', { email });
  },

  // Bağlantıdaki belirteci doğrular; geçersiz ya da süresi dolmuşsa 400 + `message`.
  dogrula: async (belirtec: string): Promise<BelirtecBilgisi> => {
    const { data } = await parolaClient.get<BelirtecBilgisi>('/api/parola/belirle', {
      params: { t: belirtec },
    });
    return data;
  },

  belirle: async (belirtec: string, parola: string): Promise<void> => {
    await parolaClient.post('/api/parola/belirle', { belirtec, parola });
  },
};

/** Sunucu kuralının istemci aynası: en az 8 karakter, bir büyük, bir küçük harf, bir rakam. */
export const PAROLA_KURALI = 'En az 8 karakter; en az bir büyük harf, bir küçük harf ve bir rakam.';

// Harf sınıfları Unicode, sunucudaki `ParolaKurali.cs` ile aynı: "Şifre123" geçerlidir.
export function parolaKuralaUyar(parola: string): boolean {
  return parola.length >= 8 && /\p{Lu}/u.test(parola) && /\p{Ll}/u.test(parola) && /[0-9]/.test(parola);
}

/** Hata gövdesindeki `message`i ve durum kodunu okur; ağ hatasında ikisi de boş kalır. */
export function sunucuHatasi(err: unknown): { durum?: number; mesaj?: string } {
  if (!axios.isAxiosError(err)) return {};
  const govde = err.response?.data as { message?: unknown } | undefined;
  return {
    durum: err.response?.status,
    mesaj: typeof govde?.message === 'string' && govde.message ? govde.message : undefined,
  };
}
